import { createAsyncThunk } from "@reduxjs/toolkit";
import { type ExportCaseParams } from "../../../domain/entities/compliance";
import { type ComplianceDispatch } from "../../config";
import { type ExtraArgument } from "../../extra-argument";
import { type State } from "../../state";
import { thunkTypes } from "../thunk-types";

/** Hands the browser a file to save (no-op where object URLs are unavailable,
 *  e.g. jsdom). */
const saveBlob = (blob: Blob, fileName: string) => {
  if (typeof URL.createObjectURL !== "function") return;
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
};

/**
 * Exports the case as PDF: the backend renders it and records pdf_exported
 * (with both flags) before answering; the browser saves the file. Only the file
 * name reaches the store — the Blob itself is not serialisable.
 */
export const exportCase = createAsyncThunk<
  { fileName: string },
  ExportCaseParams,
  { dispatch: ComplianceDispatch; extra: ExtraArgument; state: State }
>(thunkTypes.EXPORT_CASE, async (params, { extra }) => {
  const { blob, fileName } = await extra.complianceRepo.exportCase(params);
  saveBlob(blob, fileName);
  return { fileName };
});
